import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function advancedQueryFunc(data) {
  return request({
    url: URL.booking.mblManagement.advancedQueryUrl,
    method: 'post',
    data
  })
}

export function registerFunc(data) {
  return request({
    url: URL.booking.mblManagement.registerUrl,
    method: 'post',
    data
  })
}

export function cancellationFunc(data) {
  return request({
    url: URL.booking.mblManagement.cancellationUrl,
    method: 'post',
    data
  })
}

export function deleteFunc(data) {
  return request({
    url: URL.booking.mblManagement.deleteUrl,
    method: 'post',
    data
  })
}

/**
 * 分配
 * @param data
 * @returns {AxiosPromise}
 */
export function allocationFunc(data) {
  return request({
    url: URL.booking.mblManagement.allocationUrl,
    method: 'post',
    data
  })
}

/**
 * 设置提醒
 * @param data
 * @returns {AxiosPromise}
 */
export function setReminderFunc(data) {
  return request({
    url: URL.booking.mblManagement.setReminderUrl,
    method: 'post',
    data
  })
}
/**
 * 获取提醒
 * @param data
 * @returns {AxiosPromise}
 */
export function getReminderFunc(data) {
  return request({
    url: URL.booking.mblManagement.getReminderUrl,
    method: 'post',
    data
  })
}

/**
 * 校验余量提醒
 * @param data
 * @returns {AxiosPromise}
 */
export function checkReminderFunc(data) {
  return request({
    url: URL.booking.mblManagement.checkReminderUrl,
    method: 'post',
    data
  })
}

/**
 * 校验主单号是否存在 或已被使用
 * @param data
 * @returns {AxiosPromise}
 */
export function checkMblNoDataFunc(data) {
  return request({
    url: URL.booking.mblManagement.checkMblNoDataUrl,
    method: 'post',
    data
  })
}

/**
 * 校验业务是否领用主单号
 * @param data
 * @returns {AxiosPromise}
 */
export function checkJobHasMblFunc(data) {
  return request({
    url: URL.booking.mblManagement.checkJobHasMblUrl,
    method: 'post',
    data
  })
}

export function importFunc(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.mblManagement.importUrl,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    },
    method: 'post',
    data
  })
}
